import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  columns: [],
  workWeekColumns: [],
  calculatedAt: null,
  count: 8,
  customStartDate: null,
  weekOffset: 0
};

const weekDataSlice = createSlice({
  name: 'weekData',
  initialState,
  reducers: {
    setWeekData: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },
    resetWeekData: () => initialState
  }
});

export const { setWeekData, resetWeekData } = weekDataSlice.actions;
export default weekDataSlice.reducer;